import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RenaultCampaignGalleryImageByTagDTO } from 'src/app/models/renault-campaign-gallery-dto';
import { GalleryService } from 'src/app/services/gallery.service';
import { heightContentAnimation } from 'src/app/animations';

@Component({
  selector: 'campaign-gallery-modal',
  templateUrl: './campaign-gallery-modal.component.html',
  styleUrls: ['./campaign-gallery-modal.component.scss'],
  animations: [heightContentAnimation]
})
export class CampaignGalleryModalComponent implements OnInit {

  @Input() tags: string[];
  @Input() selectedImageUri: string | null = null;
  @Input() selectedImage: RenaultCampaignGalleryImageByTagDTO | null = null;

  imageList: RenaultCampaignGalleryImageByTagDTO[] = [];
  isLoading = true;

  constructor(public activeModal: NgbActiveModal, private galleryService: GalleryService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getCampaignGalleryImages(this.tags);
  }

  getCampaignGalleryImages(tags: string[]) {
    this.galleryService.getImagesByTags(tags).subscribe(images => {
        this.imageList = images;
      },
      error => {
        console.error('Error al cargar las imágenes:', error);
        this.toastr.error('Error al cargar las imágenes');
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  selectImage(image: RenaultCampaignGalleryImageByTagDTO) {
    this.selectedImage = image;
    this.selectedImageUri = image.FileUri;
  }

  closeModal() {
    this.activeModal.close();
  }

  selectAndClose(image: RenaultCampaignGalleryImageByTagDTO) {
    this.activeModal.close(image);
  }

  getImageUrl(image: RenaultCampaignGalleryImageByTagDTO): string {
    return image.FileUri;
  }

  getImageAlt(image: RenaultCampaignGalleryImageByTagDTO): string {
    return image.Title;
  }
}
